module.exports = __webpack_public_path__ + "static/filmov+-6ea48f5744186985067efd4d8d8e665e.svg";